import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import DialogCloseButton from '../../../../../../buttons/DialogCloseButton';
import ImageCropper from '../../../../MediaPickers/common/ImageCropper';
import ImageCropperActions from '../../../../MediaPickers/common/ImageCropperActions';
import MediaPickersConstants from '../../../../MediaPickers/MediaPickersConstants';
import { mediaPickerActions } from '../../../../MediaPickers/store';
import { MEDIA_USAGE_TYPE } from '../../../../CreatePageConstants';

const ParticleImageCropperDialog = (props) => {
    const { imageCropperVisible, imageCropperData, hideImageCropper } = props;
    const [dialogEntered, setDialogEntered] = useState(false);

    const isParticleCropper = imageCropperData?.mediaUsageType === MEDIA_USAGE_TYPE.PARTICLE;
    const open = imageCropperVisible && isParticleCropper;

    const handleClose = () => {
        hideImageCropper();
    };

    const handleEntered = () => {
        setDialogEntered(true);
    };

    const handleExited = () => {
        setDialogEntered(false);
    };

    if (!open) {
        return null;
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            TransitionProps={{
                onEntered: handleEntered,
                onExited: handleExited
            }}
        >
            <DialogTitle>
                Crop Particle Image
                <DialogCloseButton onClick={handleClose} />
            </DialogTitle>
            <DialogContent>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    py: 2,
                    minHeight: 350
                }}>
                    {dialogEntered && <ImageCropper cropperConfiguration={MediaPickersConstants.IMAGE_CROPPER_CONFIGURATION.PARTICLE} />}
                </Box>
            </DialogContent>
            <DialogActions>
                <ImageCropperActions />
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    const { imageCropperVisible, imageCropperData } = state.mediaPicker;
    return { 
        imageCropperVisible,
        imageCropperData
    };
};

const mapDispatchToProps = (dispatch) => ({
    hideImageCropper: () => dispatch(mediaPickerActions.hideImageCropper())
});

export default connect(mapStateToProps, mapDispatchToProps)(ParticleImageCropperDialog);
